import React, { useCallback, useLayoutEffect, useRef, useState } from "react";

/** Nakłada ramki na proporcje strony; przewijany jest tylko obszar dokumentu. */
export default function HighlightedPage({ url, regions, title, onError }) {
  const viewport = useRef(null);
  const sheet = useRef(null);
  const [zoom, setZoom] = useState(() => {
    const left = Math.min(...regions.map((region) => region.left));
    const right = Math.max(
      ...regions.map((region) => region.left + region.width),
    );
    return Math.min(
      200,
      Math.max(100, Math.floor((0.8 / (right - left)) * 4) * 25),
    );
  });

  const centerSource = useCallback(() => {
    const container = viewport.current;
    const page = sheet.current;
    if (!container || !page || !regions.length) return;
    const top = Math.min(...regions.map((region) => region.top));
    const left = Math.min(...regions.map((region) => region.left));
    const right = Math.max(
      ...regions.map((region) => region.left + region.width),
    );
    const bottom = Math.max(
      ...regions.map((region) => region.top + region.height),
    );
    const visibleHeight = Math.max(
      100,
      Math.min(
        container.clientHeight,
        window.innerHeight -
          Math.max(0, container.getBoundingClientRect().top) -
          24,
      ),
    );
    container.scrollTop = Math.max(
      0,
      ((top + bottom) / 2) * page.clientHeight - visibleHeight / 2,
    );
    container.scrollLeft = Math.max(
      0,
      ((left + right) / 2) * page.clientWidth - container.clientWidth / 2,
    );
  }, [regions]);

  useLayoutEffect(centerSource, [centerSource, zoom]);

  return (
    <>
      <div className="premium-source-controls" aria-label="Narzędzia podglądu">
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={centerSource}
        >
          Pokaż zaznaczenie
        </button>
        <div className="premium-zoom-controls">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            aria-label="Pomniejsz"
            disabled={zoom === 100}
            onClick={() => setZoom((value) => value - 25)}
          >
            −
          </button>
          <span aria-live="polite">{zoom}%</span>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            aria-label="Powiększ"
            disabled={zoom === 250}
            onClick={() => setZoom((value) => value + 25)}
          >
            +
          </button>
        </div>
      </div>
      <div
        className="premium-source-viewport"
        ref={viewport}
        tabIndex={0}
        role="region"
        aria-label="Strona dokumentu z zaznaczonym źródłem"
      >
        <div
          className="premium-source-sheet"
          ref={sheet}
          style={{ width: `${zoom}%` }}
        >
          <img src={url} alt={title} onLoad={centerSource} onError={onError} />
          {regions.map((region, index) => (
            <div
              key={index}
              className="premium-source-region"
              aria-label={`Zaznaczone źródło ${index + 1}`}
              style={{
                left: `${region.left * 100}%`,
                top: `${region.top * 100}%`,
                width: `${region.width * 100}%`,
                height: `${region.height * 100}%`,
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
}
